import { useEffect, useState } from "react";
import { BACKEND_URL } from "../../utils/api";
import useToken from "../../../../hooks/auth/useToken";

interface OrangeCameroonDisbursementBalance {
  orange_disbursement_balance: number;
  currency: string;
  firstName?: string;
  lastName?: string;
}

export default function useOrangeCameroonDisbursementBalance() {
  const [balance, setBalance] = useState<OrangeCameroonDisbursementBalance | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<any>();
  const { token } = useToken();

  const getBalance = async () => {
    if (!token) {
      setLoading(false);
      return;
    }

    setLoading(true);
    try {
      const response = await fetch(`${BACKEND_URL}/payment/get_balance_orange_cameroon_disbursement`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        throw new Error("Failed to fetch Orange Cameroon Disbursement balance");
      }

      const data = await response.json();
      console.log("Orange Disbursement API Response:", data);

      // Vérifier si la réponse contient les données attendues
      if (data && data.data) {
        setBalance(data.data);
      } else {
        console.warn("Unexpected response structure:", data);
        setBalance(null);
      }
      setLoading(false);
    } catch (error) {
      console.error("Error fetching Orange Cameroon Disbursement balance:", error);
      setError(error);
      setBalance(null);
      setLoading(false);
    }
  };

  useEffect(() => {
    getBalance();
  }, [token]);

  return {
    balance,
    loading,
    error,
    refetch: getBalance,
  };
}
